import React, { useEffect, useState } from "react";
import { Tabs } from "antd";
import { IoStorefront } from "react-icons/io5";
import Cookies from "js-cookie";
import qs from "qs";

import {
  AxiosCustomGet,
  AxiosCustomPut,
} from "../../../components/axios/AxiosCustom";
import Config from "../../../components/axios/Config";
import Breadcrumb from "../../../components/common/Breadcrumb/Breadcrumb";
import Title from "../../../components/common/Title/Title";
import ChooseOutletDialog from "../../finance/components/ChooseOutletDialog";
import CapitalOutlet from "./components/CapitalOutlet";
import CashOutlet from "./components/CashOutlet";
import EditCapitalCashDialog from "./components/EditCapitalCashDialog";
import SwalToast from "../../../components/helpers/SwalToast";

import { convertOutletList } from "../../finance/helpers";
import { convertCapitalOutletList, convertCashOutletList } from "./helpers";

import {
  CAPITAL_OUTLET_TYPE,
  initCapitalFilterInput,
  initCashFilterInput,
} from "./constants";

const TabPane = Tabs.TabPane;

const CapitalCashOutlet = () => {
  const [capitalTablePagination, setCapitalTablePagination] = useState({});
  const [capitalOutletCheckedList, setCapitalOutletCheckedList] = useState([]);
  const [capitalIndeterminate, setCapitalIndeterminate] = useState(false);
  const [capitalOutletCheckAll, setCapitalOutletCheckAll] = useState(false);
  const [capitalList, setCapitalList] = useState([]);
  const [capitalFilterInput, setCapitalFilterInput] = useState(
    initCapitalFilterInput
  );
  const [capitalPageSize, setCapitalPageSize] = useState(10);

  const [cashTablePagination, setCashTablePagination] = useState({});
  const [cashOutletCheckedList, setCashOutletCheckedList] = useState([]);
  const [cashIndeterminate, setCashIndeterminate] = useState(false);
  const [cashOutletCheckAll, setCashOutletCheckAll] = useState(false);
  const [cashList, setCashList] = useState([]);
  const [cashFilterInput, setCashFilterInput] = useState(initCashFilterInput);
  const [cashPageSize, setCashPageSize] = useState(10);

  const [tabState, setTabState] = useState(CAPITAL_OUTLET_TYPE);
  const [loading, setLoading] = useState(false);
  const [outletList, setOutletList] = useState([]);
  const [totalOutlets, setTotalOutlets] = useState(0);
  const [isOutletDialogOpen, setIsOutletDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editMinValue, setEditMinValue] = useState("");
  const [editMaxValue, setEditMaxValue] = useState("");
  const [errors, setErrors] = useState({});
  const [selectedID, setSelectedID] = useState("");

  const getOutlet = () => {
    let url = `${process.env.REACT_APP_BASE_API_URL}outlet/all`;
    AxiosCustomGet(
      url,
      Config({
        Authorization: `Bearer ${Cookies.get("access_token")}`,
      }),
      (response) => {
        setOutletList(convertOutletList(response.data.data));
        setTotalOutlets(response.data.data.length);

        const outletListId = response.data.data.map((outlet) => {
          return outlet.id;
        });

        setCapitalOutletCheckedList(outletListId);
        setCapitalIndeterminate(false);
        setCapitalOutletCheckAll(true);

        setCashOutletCheckedList(outletListId);
        setCashIndeterminate(false);
        setCashOutletCheckAll(true);
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data outlet: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getCapitalOutletList = () => {
    setLoading(true);
    const data = {
      outlet_id_list: capitalFilterInput.outlets,
      page: capitalFilterInput.page,
      size: parseInt(capitalFilterInput.pageSize),
      sorting_field: capitalFilterInput.sortingField,
      sorting_order: capitalFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-capital/config`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setCapitalList(
          convertCapitalOutletList(
            response.data.data.items.outlet_capital_config_list
          )
        );
        setCapitalTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data modal: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const getCashOutletList = () => {
    setLoading(true);
    const data = {
      outlet_id_list: cashFilterInput.outlets,
      page: cashFilterInput.page,
      size: parseInt(cashFilterInput.pageSize),
      sorting_field: cashFilterInput.sortingField,
      sorting_order: cashFilterInput.sortingOrder,
    };

    let url = `${process.env.REACT_APP_BASE_API_URL}outlet-cash/config`;
    AxiosCustomGet(
      url,
      Config(
        {
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        },
        data,
        (params) => {
          return qs.stringify(params, { arrayFormat: "repeat" });
        }
      ),
      (response) => {
        setLoading(false);
        setCashList(
          convertCashOutletList(
            response.data.data.items.outlet_cash_config_list
          )
        );
        setCashTablePagination({
          current: response.data.data.page,
          pageSize: response.data.data.per_page,
          total: response.data.data.total_item,
        });
      },
      (error) => {
        if (error.response) {
          SwalToast.fire({
            icon: "error",
            title: `Gagal mengambil data kas: ${error?.response?.data?.error?.message}`,
          });
        } else {
          SwalToast.fire({
            icon: "error",
            title: "Whoops, something went wrong",
          });
        }
      }
    );
  };

  const handleTextInputChange = (event) => {
    const { value } = event.target;

    if (tabState === CAPITAL_OUTLET_TYPE) {
      setCapitalPageSize(value);
    } else {
      setCashPageSize(value);
    }
  };

  const handleEnter =
    (type = "enter") =>
      (event) => {
        const { name, value } = event.target;
        if (event.keyCode === 13 || type === "blur") {
          if (tabState === CAPITAL_OUTLET_TYPE) {
            if (value === "") {
              setCapitalPageSize(10);
            }
            setCapitalFilterInput((prev) => ({
              ...prev,
              [name]: value === "" ? 10 : value,
              page: 1,
            }));
          } else {
            if (value === "") {
              setCashPageSize(10);
            }
            setCashFilterInput((prev) => ({
              ...prev,
              [name]: value === "" ? 10 : value,
              page: 1,
            }));
          }
        }
      };

  const handleSingleOutletChange = (list) => {
    if (tabState === CAPITAL_OUTLET_TYPE) {
      setCapitalOutletCheckedList(list);
      setCapitalIndeterminate(!!list.length && list.length < outletList.length);
      setCapitalOutletCheckAll(list.length === outletList.length);
    } else {
      setCashOutletCheckedList(list);
      setCashIndeterminate(!!list.length && list.length < outletList.length);
      setCashOutletCheckAll(list.length === outletList.length);
    }
  };

  const handleOutletCheckAllChange = (event) => {
    const outletListId = outletList.map((outlet) => {
      return outlet.value;
    });

    if (tabState === CAPITAL_OUTLET_TYPE) {
      setCapitalOutletCheckedList(event.target.checked ? outletListId : []);
      setCapitalIndeterminate(false);
      setCapitalOutletCheckAll(event.target.checked);
    } else {
      setCashOutletCheckedList(event.target.checked ? outletListId : []);
      setCashIndeterminate(false);
      setCashOutletCheckAll(event.target.checked);
    }
  };

  const handleOutletButtonClick = () => {
    setIsOutletDialogOpen(true);
  };

  const handleOutletSave = () => {
    if (tabState === CAPITAL_OUTLET_TYPE) {
      setCapitalFilterInput((prev) => ({
        ...prev,
        outlets: capitalOutletCheckedList,
        page: 1,
      }));
    } else {
      setCashFilterInput((prev) => ({
        ...prev,
        outlets: cashOutletCheckedList,
        page: 1,
      }));
    }
    setIsOutletDialogOpen(false);
  };

  const handleCancel = () => {
    setIsOutletDialogOpen(false);
    setIsEditDialogOpen(false);

    if (errors) {
      setErrors({});
    }
  };

  const handleTabChange = (key) => {
    setTabState(key);
  };

  const handleTableChange = (pagination, _, sorter) => {
    if (tabState === CAPITAL_OUTLET_TYPE) {
      setCapitalFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        size: parseInt(pagination.pageSize),
        sortingField: sorter?.column?.backend_key || null,
        sortingOrder:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
              ? "DESC"
              : null,
      }));
    } else {
      setCashFilterInput((prev) => ({
        ...prev,
        page: pagination.current,
        size: parseInt(pagination.pageSize),
        sortingField: sorter?.column?.backend_key || null,
        sortingOrder:
          sorter?.order === "ascend"
            ? "ASC"
            : sorter?.order === "descend"
              ? "DESC"
              : null,
      }));
    }
  };

  const handleEditButtonClick = (data) => {
    const minValue = Number(data?.minAmount?.split(" ")[1].replaceAll(".", ""));
    const maxValue =
      tabState === CAPITAL_OUTLET_TYPE
        ? Number(data?.maxAmount?.props?.children?.[1]?.replaceAll(".", ""))
        : Number(data?.maxAmount?.split(" ")[1].replaceAll(".", ""));

    setSelectedID(data.outletID);
    setEditMinValue(minValue);
    setEditMaxValue(maxValue);
    setIsEditDialogOpen(true);
  };

  const handleEditInputChange = (field, value) => {
    if (field === "max-amount") {
      setEditMaxValue(value);
      if (errors.maxAmount) {
        setErrors((prev) => ({
          ...prev,
          maxAmount: null,
        }));
      }
    } else if (field === "min-amount") {
      setEditMinValue(value);
      if (errors.minAmount) {
        setErrors((prev) => ({
          ...prev,
          minAmount: null,
        }));
      }
    }
  };

  const validate = () => {
    const newErrors = {};

    if (!editMinValue || editMinValue === "") {
      newErrors.minAmount = "Jumlah minimal tidak boleh kosong";
    }
    if (!editMaxValue || editMaxValue === "") {
      newErrors.maxAmount = "Jumlah maksimal tidak boleh kosong";
    }
    return newErrors;
  };

  const handleEditSave = () => {
    const newErrors = validate();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const data = {
        min: parseInt(editMinValue),
        max: parseInt(editMaxValue),
      };
      let url = process.env.REACT_APP_BASE_API_URL;
      if (tabState === CAPITAL_OUTLET_TYPE) {
        url += `outlet-capital/config/${selectedID}`;
      } else {
        url += `outlet-cash/config/${selectedID}`;
      }

      AxiosCustomPut(
        url,
        data,
        Config({
          Authorization: `Bearer ${Cookies.get("access_token")}`,
        }),
        () => {
          SwalToast.fire({
            icon: "success",
            title: "Sukses Mengubah Data",
          });
        },
        (error) => {
          if (error?.response) {
            SwalToast.fire({
              icon: "error",
              title: `Gagal: ${error?.response?.data?.error?.message}`,
            });
          } else {
            SwalToast.fire({
              icon: "error",
              title: "Whoops, something went wrong",
            });
          }
        },
        () => {
          setEditMinValue("");
          setEditMaxValue("");
          setSelectedID("");
          setIsEditDialogOpen(false);
          if (tabState === CAPITAL_OUTLET_TYPE) {
            getCapitalOutletList();
          } else {
            getCashOutletList();
          }
        }
      );
    }
  };

  useEffect(() => {
    if (tabState === CAPITAL_OUTLET_TYPE) {
      getCapitalOutletList();
    } else {
      getCashOutletList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [capitalFilterInput, cashFilterInput, tabState]);

  useEffect(() => {
    getOutlet();
  }, []);

  return (
    <div>
      <div className="px-3">
        <div className="py-4 d-flex">
          <div className="d-flex flex-column" style={{ fontSize: "13px" }}>
            <Title text={"Pengaturan Modal & Kas Outlet"} />
            <Breadcrumb current={"Pengaturan Modal & Kas Outlet"} />
          </div>
          <div className="ml-auto d-flex align-items-center">
            <div className="total-container">
              <IoStorefront className="total-icon" />{" "}
              <span style={{ fontWeight: "bold" }}>{totalOutlets}</span> Total
              Outlet
            </div>
          </div>
        </div>
        <Tabs defaultActiveKey="capital" onChange={handleTabChange}>
          <TabPane tab="Modal Outlet" key="capital">
            <CapitalOutlet
              handleEditButtonClick={handleEditButtonClick}
              data={capitalList}
              loading={loading}
              handleTableChange={handleTableChange}
              tablePagination={capitalTablePagination}
              handleEnter={handleEnter}
              handleOutletButtonClick={handleOutletButtonClick}
              pageSizeValue={capitalPageSize}
              handleInputChange={handleTextInputChange}
            />
          </TabPane>
          <TabPane tab="Kas Outlet" key="cash">
            <CashOutlet
              handleEditButtonClick={handleEditButtonClick}
              data={cashList}
              loading={loading}
              handleTableChange={handleTableChange}
              tablePagination={cashTablePagination}
              handleEnter={handleEnter}
              handleOutletButtonClick={handleOutletButtonClick}
              pageSizeValue={cashPageSize}
              handleInputChange={handleTextInputChange}
            />
          </TabPane>
        </Tabs>

        <ChooseOutletDialog
          title={"Pilih Cabang/Outlet"}
          visible={isOutletDialogOpen}
          handleSave={handleOutletSave}
          handleCancel={handleCancel}
          data={outletList}
          onCheckAllChange={handleOutletCheckAllChange}
          onSingleChange={handleSingleOutletChange}
          indeterminate={
            tabState === CAPITAL_OUTLET_TYPE
              ? capitalIndeterminate
              : cashIndeterminate
          }
          outletCheckAll={
            tabState === CAPITAL_OUTLET_TYPE
              ? capitalOutletCheckAll
              : cashOutletCheckAll
          }
          outletCheckedList={
            tabState === CAPITAL_OUTLET_TYPE
              ? capitalOutletCheckedList
              : cashOutletCheckedList
          }
        />
      </div>
      <EditCapitalCashDialog
        visible={isEditDialogOpen}
        handleCancel={handleCancel}
        handleSave={handleEditSave}
        actionButtonText={"Simpan"}
        title={`Ubah Pengaturan ${tabState === CAPITAL_OUTLET_TYPE ? "Modal" : "Kas"
          }`}
        handleChange={handleEditInputChange}
        errors={errors}
        minValue={editMinValue}
        maxValue={editMaxValue}
      />
    </div>
  );
};

export default CapitalCashOutlet;
